import { useEffect, useState } from 'react';

/** SSR-safe and StrictMode-safe; re-subscribes if the query itself changes. */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() =>
    typeof window === 'undefined' ? false : window.matchMedia(query).matches,
  );

  useEffect(() => {
    const list = window.matchMedia(query);
    const onChange = (event: MediaQueryListEvent) => setMatches(event.matches);
    setMatches(list.matches);
    list.addEventListener('change', onChange);
    return () => list.removeEventListener('change', onChange);
  }, [query]);

  return matches;
}

/**
 * Drag is desktop-only, and this is what gates lazy-loading the drag code so phones
 * never download ~35–40kB gzipped of it. `pointer: fine` matters as much as the width:
 * a touch laptop at 1400px still has no usable drag affordance.
 */
export function useDragEnabled(): boolean {
  return useMediaQuery('(min-width: 1024px) and (pointer: fine)');
}
